export default {
  sellerPageTitle: {
    id: 'seller_page_title',
    defaultMessage: 'Seller reviews and info',
  },
  sellerPageTabsLabel: {
    id: 'seller_page_tabs_label',
    defaultMessage: 'Seller navigation tabs',
  },
  sellerPageReviewsTab: {
    id: 'seller_page_reviews_tab',
    defaultMessage: 'Reviews',
  },
  sellerPageItemsTab: {
    id: 'seller_page_items_tab',
    defaultMessage: 'Items',
  },
  sellerPageAboutTab: {
    id: 'seller_page_about_tab',
    defaultMessage: 'About',
  },
} as const
